// store/admin/college-management/store/_actionTypes.js

// Existing action types
export const FETCH_COLLEGES_REQUEST = 'FETCH_COLLEGES_REQUEST';
export const FETCH_COLLEGES_SUCCESS = 'FETCH_COLLEGES_SUCCESS';
export const FETCH_COLLEGES_FAILURE = 'FETCH_COLLEGES_FAILURE';

export const FETCH_DEGREES_FOR_COLLEGE_REQUEST = 'FETCH_DEGREES_FOR_COLLEGE_REQUEST';
export const FETCH_DEGREES_FOR_COLLEGE_SUCCESS = 'FETCH_DEGREES_FOR_COLLEGE_SUCCESS';
export const FETCH_DEGREES_FOR_COLLEGE_FAILURE = 'FETCH_DEGREES_FOR_COLLEGE_FAILURE';

export const CREATE_COLLEGE_REQUEST = 'CREATE_COLLEGE_REQUEST';
export const CREATE_COLLEGE_SUCCESS = 'CREATE_COLLEGE_SUCCESS';
export const CREATE_COLLEGE_FAILURE = 'CREATE_COLLEGE_FAILURE';

export const APPROVE_COLLEGE_REQUEST = 'APPROVE_COLLEGE_REQUEST';
export const APPROVE_COLLEGE_SUCCESS = 'APPROVE_COLLEGE_SUCCESS';
export const APPROVE_COLLEGE_FAILURE = 'APPROVE_COLLEGE_FAILURE';

export const DELETE_COLLEGE_REQUEST = 'DELETE_COLLEGE_REQUEST';
export const DELETE_COLLEGE_SUCCESS = 'DELETE_COLLEGE_SUCCESS';
export const DELETE_COLLEGE_FAILURE = 'DELETE_COLLEGE_FAILURE';

export const TOGGLE_COLLEGE_SUBSCRIPTION_REQUEST = 'TOGGLE_COLLEGE_SUBSCRIPTION_REQUEST';
export const TOGGLE_COLLEGE_SUBSCRIPTION_SUCCESS = 'TOGGLE_COLLEGE_SUBSCRIPTION_SUCCESS';
export const TOGGLE_COLLEGE_SUBSCRIPTION_FAILURE = 'TOGGLE_COLLEGE_SUBSCRIPTION_FAILURE';

// Additional action types
export const UPDATE_COLLEGE_REQUEST = 'UPDATE_COLLEGE_REQUEST';
export const UPDATE_COLLEGE_SUCCESS = 'UPDATE_COLLEGE_SUCCESS';
export const UPDATE_COLLEGE_FAILURE = 'UPDATE_COLLEGE_FAILURE';

export const SEARCH_COLLEGES_REQUEST = 'SEARCH_COLLEGES_REQUEST';
export const SEARCH_COLLEGES_SUCCESS = 'SEARCH_COLLEGES_SUCCESS';
export const SEARCH_COLLEGES_FAILURE = 'SEARCH_COLLEGES_FAILURE';

export const GET_COLLEGE_STATISTICS_REQUEST = 'GET_COLLEGE_STATISTICS_REQUEST';
export const GET_COLLEGE_STATISTICS_SUCCESS = 'GET_COLLEGE_STATISTICS_SUCCESS';
export const GET_COLLEGE_STATISTICS_FAILURE = 'GET_COLLEGE_STATISTICS_FAILURE';

export const BULK_APPROVE_COLLEGES_REQUEST = 'BULK_APPROVE_COLLEGES_REQUEST';
export const BULK_APPROVE_COLLEGES_SUCCESS = 'BULK_APPROVE_COLLEGES_SUCCESS';
export const BULK_APPROVE_COLLEGES_FAILURE = 'BULK_APPROVE_COLLEGES_FAILURE';

export const SUSPEND_COLLEGE_REQUEST = 'SUSPEND_COLLEGE_REQUEST';
export const SUSPEND_COLLEGE_SUCCESS = 'SUSPEND_COLLEGE_SUCCESS';
export const SUSPEND_COLLEGE_FAILURE = 'SUSPEND_COLLEGE_FAILURE';

export const GET_COLLEGE_BY_ID_REQUEST = 'GET_COLLEGE_BY_ID_REQUEST';
export const GET_COLLEGE_BY_ID_SUCCESS = 'GET_COLLEGE_BY_ID_SUCCESS';
export const GET_COLLEGE_BY_ID_FAILURE = 'GET_COLLEGE_BY_ID_FAILURE';

// UI State actions
export const CLEAR_COLLEGE_ERROR = 'CLEAR_COLLEGE_ERROR';
export const SET_COLLEGE_LOADING = 'SET_COLLEGE_LOADING';
export const RESET_COLLEGE_STATE = 'RESET_COLLEGE_STATE';